// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"375":"f2315f04","832":"7f30530b","963":"abc4c60e"}[chunkId] + ".chunk.css";
};